export const FILE_UPLOADERS_MACHINE_ID = 'fileUploadersMachine'

export const INITIAL = 'INITIAL'
export const INITIAL_STATE = 'initial'

export const SPAWN_CHILDREN_FILE_UPLOADERS = 'SPAWN_CHILDREN_FILE_UPLOADERS'
export const SPAWN_CHILDREN_FILE_UPLOADERS_STATE = 'spawnChildrenFileUploaders'

export const UPDATE_CONFIG_DETAILS = 'UPDATE_CONFIG_DETAILS'
export const UPDATE_S3_CLIENT = 'UPDATE_S3_CLIENT'

export const GET_AWS_CREDENTIALS = 'GET_AWS_CREDENTIALS'
export const GET_AWS_CREDENTIALS_STATE = 'getAWSCredentials'

export const CONFIGURE_AWS = 'CONFIGURE_AWS'
export const CONFIGURE_AWS_STATE = 'configureAWS'

export const SEND_UPDATED_CONFIG_DETAILS_TO_CHILDREN =
  'SEND_UPDATED_CONFIG_DETAILS_TO_CHILDREN'

export const SEND_UPDATED_CONFIG_DETAILS_TO_CHILDREN_STATE =
  'sendUpdatedConfigDetailsToChildren'

export const UPDATE_CHILDREN_S3_CLIENT_DETAILS =
  'UPDATE_S3_CLIENT_AND_CONFIG_DETAILS'

export const SPAWN_NEW_FILE_UPLOADER = 'SPAWN_NEW_FILE_UPLOADER'

export const GET_AWS_CREDENTIALS_FAILURE = 'GET_AWS_CREDENTIALS_FAILURE'
export const GET_AWS_CREDENTIALS_FAILURE_STATE = 'getAWSCredentialsFailure'

export const ON_SUCCESS_GETTING_FILE_UPLOADER_CONFIG =
  'ON_SUCCESS_GETTING_FILE_UPLOADER_CONFIG'

export const ON_FAILURE_GETTING_FILE_UPLOADER_CONFIG =
  'ON_FAILURE_GETTING_FILE_UPLOADER_CONFIG'

export const states = {
  initial: INITIAL_STATE,
  spawnChildrenFileUploaders: SPAWN_CHILDREN_FILE_UPLOADERS_STATE,
  getAWSCredentials: GET_AWS_CREDENTIALS_STATE,
  configureAWS: CONFIGURE_AWS_STATE,
  sendUpdatedConfigDetailsToChildren:
    SEND_UPDATED_CONFIG_DETAILS_TO_CHILDREN_STATE,
  getAWSCredentialsFailure: GET_AWS_CREDENTIALS_FAILURE_STATE
}

export const events = {
  initial: INITIAL,
  spawnChildrenFileUploaders: SPAWN_CHILDREN_FILE_UPLOADERS,
  updateConfigDetails: UPDATE_CONFIG_DETAILS,
  updateS3Client: UPDATE_S3_CLIENT,
  getAWSCredentials: GET_AWS_CREDENTIALS,
  configureAWS: CONFIGURE_AWS,
  sendUpdatedConfigDetailsToChildren: SEND_UPDATED_CONFIG_DETAILS_TO_CHILDREN,
  updateChildrenS3ClientDetails: UPDATE_CHILDREN_S3_CLIENT_DETAILS,
  spawnNewFileUploader: SPAWN_NEW_FILE_UPLOADER,
  getAWSCredentialsFailure: GET_AWS_CREDENTIALS_FAILURE,
  onSuccessGettingFileUploaderConfig: ON_SUCCESS_GETTING_FILE_UPLOADER_CONFIG,
  onFailureGettingFileUploaderConfig: ON_FAILURE_GETTING_FILE_UPLOADER_CONFIG
}

export { states as fileUploadersMachineStates }
export { events as fileUploadersMachineEvents }
